var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayOnRepeat = function SvgPlayOnRepeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.53 1.47a.75.75 0 0 0-1.06 1.06l2.72 2.72H7a6.75 6.75 0 0 0 0 13.5h.09a.75.75 0 0 0 0-1.5H7a5.25 5.25 0 1 1 0-10.5h4.19L8.47 9.47a.75.75 0 1 0 1.06 1.06l4-4a.75.75 0 0 0 0-1.06zM16.75 5.25a.75.75 0 0 0 0 1.5H17a5.25 5.25 0 1 1 0 10.5h-4.19l2.72-2.72a.75.75 0 1 0-1.06-1.06l-4 4a.75.75 0 0 0 0 1.06l4 4a.75.75 0 1 0 1.06-1.06l-2.72-2.72H17a6.75 6.75 0 0 0 0-13.5z"
  })));
};
export default SvgPlayOnRepeat;